import { Injectable } from '@angular/core';

import { AuthenticationService } from '../authentication/authentication.service';
import { DEFAULT_DOMAINS, DEFAULT_PRODUCTION_DOMAIN } from '@core/constants/white-label';
import { environment } from '@environments/environment';
import { WindowRefService } from '@core/services/helpers/window-ref.service';

@Injectable()
export class DomainGuard {
    private window: Window;

    constructor(
        private authenticationService: AuthenticationService,
        private windowRefService: WindowRefService
    ) {
        this.window = this.windowRefService.window;
    }

    canActivate(): boolean {
        let canActivate = true;

        if (environment.production && this.authenticationService.isAuthenticated()) {
            let loginDomain: string = this.authenticationService.user.domain;
            let currentDomain = this.window.location.hostname
                .split('.')
                .filter((item: string) => item !== 'www')[0];

            if (DEFAULT_DOMAINS.includes(loginDomain)) {
                loginDomain = DEFAULT_PRODUCTION_DOMAIN;
            }

            if (DEFAULT_DOMAINS.includes(currentDomain)) {
                currentDomain = DEFAULT_PRODUCTION_DOMAIN;
            }

            if (loginDomain !== currentDomain) {
                if (loginDomain === DEFAULT_PRODUCTION_DOMAIN) {
                    this.window.location.href = `https://www.${DEFAULT_PRODUCTION_DOMAIN}.tech`;
                } else {
                    this.window.location.href = `https://${loginDomain}.${DEFAULT_PRODUCTION_DOMAIN}.tech`;
                }

                this.authenticationService.logout(false).catch(() => {});
                canActivate = false;
            }
        }

        return canActivate;
    }
}
